// NOTE: Dependencies: jQuery, Defiant

(function ($) {
	$.fn.lmSlider = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$slider: this,
			$html: $('html'),
			$animationButton : $('.slider-animation-button'),
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};
		var isSliding = false;
		var isPause = false;
		var isClickedPause = false;
		
		var percentTime;
		var tick;
		var time = 3;
		var progressBarIndex = 0;

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();
			
			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$form = $context.closest('form');
			settings.$loader = settings.$form.parent();
			settings.$predictiveInput = settings.$form.find('input');	
		};

		// Toggle Active Classes
		methods.toggle = function ($context) {
			$context.toggleClass(settings.activeClass);
		};

		// On load function.
		methods.initContext = function ($context) {
			methods.setCurrentSettings($context);
			
			if($context.length) {
				$context.each(function() {
					var $slider = $(this);

					if (!$slider.hasClass('slider')) {
						$slider.imagesLoaded( function() {
							$slider.slick({
								mobileFirst: true
							});
						});
					} else if ($slider.hasClass('slider') && (!settings.$html.hasClass('is-mobile') && !settings.$html.hasClass('is-tablet')) && settings.$html.hasClass('no-touchevents')) {
						$slider.imagesLoaded( function() {
							$slider.slick({
								mobileFirst: true
							});
						});
					}
					// Support for
					else if ($slider.hasClass('slider') && settings.$html.hasClass('is-desktop') && settings.$html.hasClass('touchevents')) {
						$slider.imagesLoaded( function() {
							$slider.slick({
								mobileFirst: true
							});
						});
					}	

					// Play/Pause action			
					if ($slider.next().hasClass('slider-animation-button')){
						if(settings.$animationButton) {
							var sliderAnimationButton =  settings.$animationButton;
							sliderAnimationButton.on('click', function(){
								methods.updateAnimationButton();
							});	
						}							
					}			

					// Go to URL when clicking 
					$slider.find('.slider__slide').click(function() {
						if (isSliding) {
							event.preventDefault();
						} else {
							if ($(this).attr("data-url") != null && $(this).attr("data-url") != undefined && $(this).attr("data-url") !== "") {
								location.href=$(this).attr("data-url");
							}						
						}
					});	
				});				

				$('div[data-slick]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
					isSliding = true;		
				});

				$('div[data-slick]').on('afterChange', function(event, slick, currentSlide, nextSlide){
					isSliding = false;
					progressBarIndex = currentSlide;			
				});		
				
				$('div[data-slick]').on('swipe', function(event, slick, direction){
					if(direction === "left" && progressBarIndex < slick.slideCount){
						progressBarIndex = progressBarIndex+1;
					}
					else if(direction === "left" && progressBarIndex == slick.slideCount){
						progressBarIndex = 0;
					} else if (direction === "right" && progressBarIndex == 0 ){
						progressBarIndex = slick.slideCount;
					} else {
						progressBarIndex = progressBarIndex-1;
					}
					methods.updateProgressbar();
				});

				$('div[data-slick]').mouseover(function() {
					isPause = true;	
				});

				$('div[data-slick]').mouseout(function() {
					if(isClickedPause){
						isPause = true;
					} else {
						isPause = false;
					}											
				});
					
				$('.slider-wrapper--progress-slider div[data-slick]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
						var i,
						$slider = $(event.target),
						$slickDots = $slider.find('.slick-dots li'),
						totalLength = $slickDots.length;

						for (i = 0; i <= totalLength-1; i++) {
							if (i > nextSlide) {
								$slider.find('.slick-dots li').eq(i).removeClass('progress-active');
							} else {
								$slider.find('.slick-dots li').eq(i).addClass('progress-active');
							}
						}
				});
			}
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		methods.startProgressbar = function () {
			methods.resetProgressbar();
			percentTime = 0;			
			tick = setInterval(methods.interval, 10);
		};
		  
		methods.interval = function () {		
			if(!isPause) {
				var slickIndex = settings.$slider.attr('data-index');
				if ((settings.$slider.find('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
					progressBarIndex = settings.$slider.find('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
					methods.startProgressbar();
				} else {
					percentTime += 1 / (time + 0.1);	
					var button = settings.$slider.find('.slick-dots #slick-slide' + slickIndex + progressBarIndex + " button");
					button.css({
						background: "linear-gradient(to right, white 0%, white " + percentTime + "%, #CDCCCC " + percentTime + "%, #CDCCCC 100%)"
					});									
					if (percentTime >= 100) {					
						settings.$slider.slick('slickNext');
						progressBarIndex++;
						methods.startProgressbar();
					}
				}
			}
		};
				
		methods.updateProgressbar = function () {	
			clearInterval(tick);
			methods.startProgressbar();		
		};

		methods.cleanProgressbar = function () {	
			clearInterval(tick);
			methods.startProgressbar();
		};

		methods.resetProgressbar = function () {				
			settings.$slider.find('.slick-dots button').css({
				background: "linear-gradient(to right, #CDCCCC 0%, #CDCCCC 100%)"
			});
			clearInterval(tick);
		};	

		$('div[data-slick] .slick-dots button').each(function(index) {
			$(this).style = index;
		});	

		methods.updateAnimationButton = function (){
			var sliderAnimationButton =  settings.$animationButton;
			if(sliderAnimationButton.hasClass('slider-animation-button--pause')){					
				settings.$slider.slick('slickPause');
				sliderAnimationButton.removeClass('slider-animation-button--pause');
				sliderAnimationButton.addClass('slider-animation-button--play');
				isPause = true;
				isClickedPause = true;
			} else {
				settings.$slider.slick('slickPlay');
				sliderAnimationButton.removeClass('slider-animation-button--play');
				sliderAnimationButton.addClass('slider-animation-button--pause');
				isPause = false;
				isClickedPause = false;
			}
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this))
			if($(this).hasClass('js-progressbar')){
				methods.startProgressbar();
			}
		});
	};

	if($('div[data-slick]').length) {
		$('div[data-slick]').each(function(index) {
			$(this).attr('data-index', $('div[data-slick]').length - index - 1);
			$(this).lmSlider();
		});					
	}
}(jQuery));
